import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { message } from "antd";

const OfferLetterReject = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const rejectOfferLetter = async () => {
      try {
        const response = await axios.get(`/recruitment/offer-letters/${id}/reject`);
        message.success(response.data.message || "Offer letter rejected successfully");
      } catch (error) {
        setError(error.response?.data?.message || "Failed to reject offer letter");
        message.error(error.response?.data?.message || "Failed to reject offer letter");
      } finally {
        setLoading(false);
      }
    };

    rejectOfferLetter();
  }, [id]);

  return (
    <section className="quixoticVellumFrame">
      <div className="nebularCardinalBox">
        <h2>Offer Letter Rejection</h2>
        {loading && (
          <div className="zephyrPulseVortex">
            <div className="luminousProgressArc">
              <div className="arcaneProgressWave"></div>
            </div>
            <p className="etherealStatusNote">Processing...</p>
          </div>
        )}
        {error && (
          <div className="crimsonAlertBeacon">
            <p>{error}</p>
          </div>
        )}
        {!loading && !error && (
          <div className="verdantSuccessGlimmer">
            <p>Your offer letter has been rejected. You will be redirected shortly.</p>
          </div>
        )}
        <div className="crypticSupportWhisper">
          <p>Need assistance? Contact our support team.</p>
        </div>
      </div>
    </section>
  );
};

export default OfferLetterReject;